import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useMemo } from 'react';
import { createOption } from '@mews-commander/ui';
import { AccountingCategory } from '@mews-commander/data-access';
import { keyById } from '@mews/fp';
import { useAccountingCategoriesGetAllQuery } from '../queries/PosMicrosQuery';

export const useAccountingCategoriesOptions = () => {
    const { data } = useAccountingCategoriesGetAllQuery();

    return useMemo(
        () => ({
            accountingCategoriesOptions: getAccountingCategoriesOptions(data?.accountingCategories || []),
            accountingCategoriesById:
                data && data?.accountingCategories && array.isNonEmpty(data.accountingCategories)
                    ? keyById(data.accountingCategories)
                    : undefined,
        }),
        [data]
    );
};

const getAccountingCategoriesOptions = (items: Array<AccountingCategory>) =>
    pipe(
        items,
        array.map((item) => createOption({ value: item.id, label: item.name }))
    );
